var chunkMapping = {
	"0": [
		4700,
		4313
	],
	"74": [
		5102
	],
	"150": [
		5178
	],
	"151": [
		5179
	],
	"154": [
		5182
	],
	"155": [
		5183
	],
	"156": [
		5184
	],
	"157": [
		5185
	],
	"158": [
		5186
	],
	"159": [
		5187
	],
	"160": [
		5188
	],
	"161": [
		5189
	],
	"162": [
		5190
	],
	"163": [
		5191
	],
	"164": [
		5192
	],
	"165": [
		5193
	],
	"166": [
		5194
	],
	"167": [
		5195
	],
	"168": [
		5196
	],
	"169": [
		5197
	],
	"170": [
		5198
	]
};
var idToExternalAndNameMapping = {
	"4313": [
		"default",
		"./nuorder-components",
		4112
	],
	"4700": [
		"default",
		"./Containers",
		3796
	],
	"5102": [
		"default",
		"./OrderlessInvoices",
		3796
	],
	"5178": [
		"default",
		"./AsyncEventTracker",
		3796
	],
	"5179": [
		"default",
		"./HostWrapper",
		3796
	],
	"5182": [
		"default",
		"./CheckoutV3",
		3796
	],
	"5183": [
		"default",
		"./CheckoutConfirmation",
		3796
	],
	"5184": [
		"default",
		"./ContactCreditCards",
		3796
	],
	"5185": [
		"default",
		"./AuditDialog",
		3796
	],
	"5186": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3796
	],
	"5187": [
		"default",
		"./InvoiceDialog",
		3796
	],
	"5188": [
		"default",
		"./PaymentDueModal",
		3796
	],
	"5189": [
		"default",
		"./PaymentModal",
		3796
	],
	"5190": [
		"default",
		"./PaymentHistory",
		3796
	],
	"5191": [
		"default",
		"./PaymentConfigurations",
		3796
	],
	"5192": [
		"default",
		"./PaymentPreferences",
		3796
	],
	"5193": [
		"default",
		"./ManagePaymentProcessing",
		3796
	],
	"5194": [
		"default",
		"./MobilePaymentsWrapper",
		3796
	],
	"5195": [
		"default",
		"./Challenge",
		3796
	],
	"5196": [
		"default",
		"./ManagePaymentMethods",
		3796
	],
	"5197": [
		"default",
		"./LightspeedReports",
		3796
	],
	"5198": [
		"default",
		"./ShippingPromotionsListContainer",
		3796
	]
};
var idToRemoteMap = {
	"4313": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 4112
		}
	],
	"4700": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5102": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5178": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5179": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5182": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5183": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5184": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5185": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5186": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5187": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5188": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5189": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5190": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5191": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5192": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5193": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5194": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5195": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5196": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5197": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5198": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}